/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { ReportsFilterParams, ReportDto } from '../api/reports/reportsClient.typings';
import { ReportsActions, ReportsActionType } from '../actions/reportsActions';
import { today } from './CashBoxRegistry/cashboxDetailsReducer';
import moment from 'moment';
import { getPageLimitByScreenSize } from '../../utils/utils';

export interface ReportsState {
    reports: ReportDto[];
    filterParams: ReportsFilterParams;

    isReportShown: boolean;
    isShownDataValid: boolean;
    isLoading: boolean;

    limit: number;
    afterKey: string;
    lastRequestCashBoxesCount: number;
    isByDay: boolean;
}

const initialState: ReportsState = {
    reports: [],
    filterParams: {
        search_type: null,
        search_text: '',
        dateFrom: today.utc().clone().subtract(0, 'day').format(),
        dateTo: moment(new Date()).endOf('day').utc().format(),
        storeTypes: [],
    },
    isReportShown: false,
    isShownDataValid: false,
    isLoading: false,
    limit: getPageLimitByScreenSize(),
    afterKey: null,
    lastRequestCashBoxesCount: null,
    isByDay: false,
};

export function reportsReducer(state: ReportsState = initialState, action: ReportsActions): ReportsState {
    switch (action.type) {
        case ReportsActionType.OPEN_REPORTS_PAGE:
            return {
                ...state,
            };

        case ReportsActionType.CHANGE_REPORT_FILTERS:
            return {
                ...state,
                filterParams: action.payload,
                isShownDataValid: false,
                reports: [],
                afterKey: null,
                lastRequestCashBoxesCount: null,
            };

        case ReportsActionType.FETCH_NEXT_REPORTS_PAGE_START:
            return {
                ...state,
                isLoading: true,
            };

        case ReportsActionType.FETCH_REPORTS_PAGE_SUCCESS:
            const combinedReports: ReportDto[] = [...state.reports];
            if (action.payload.reports && action.payload.reports.length > 0)
                combinedReports.push(...action.payload.reports);
            return {
                ...state,
                reports: combinedReports,
                afterKey: action.payload.afterKey,
                lastRequestCashBoxesCount: action.payload.reports.length,
                isLoading: false,
                isShownDataValid: true,
            };

        case ReportsActionType.FETCH_REPORT_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case ReportsActionType.SHOW_REPORT_TOGGLE:
            return {
                ...state,
                isReportShown: action.payload,
            };

        case ReportsActionType.REPORT_TYPE_TOGGLE:
            return {
                ...state,
                isByDay: action.payload,
                isShownDataValid: false,
                reports: [],
                afterKey: null,
                lastRequestCashBoxesCount: null,
            };

        case ReportsActionType.DOWNLOAD_REPORT_START:
            return {
                ...state,
                isLoading: true,
            };

        case ReportsActionType.DOWNLOAD_REPORT_SUCCESS:
        case ReportsActionType.DOWNLOAD_REPORT_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case ReportsActionType.EXIT_REPORTS_PAGE:
            return {
                ...state,
                isLoading: false,
            };

        default:
            return state;
    }
}
